<template>
  <div
    class="tw-transition tw-border tw-border-gray dark:tw-border-dm-gray tw-rounded-3xl tw-p-5"
  >
    <div class="tw-flex tw-gap-3 tw-mb-2">
      <div class="tw-flex-1 tw-flex tw-items-center">
        <h2 class="tw-text-xl tw-leading-6">
          {{ document.document_type_name }}
        </h2>
        <div class="tw-ml-2">
          <el-tooltip
            :content="document.document_type_description"
          >
            <div class="tw-ml-2">
              <icon-info class="tw-text-gray-dark dark:text-dm-gray-dark" />
            </div>
          </el-tooltip>
        </div>
      </div>
      <div>
        <i-badge
          size="small"
          :type="documentStatus.color"
          class="tw-px-2"
        >
          {{ $t(documentStatus.key) }}
        </i-badge>
      </div>
    </div>
    <div
      v-if="document.note"
      class="tw-mb-4 tw-leading-5"
    >
      {{ document.note }}
    </div>
    <div class="tw-flex tw-flex-col tw-gap-2 tw-justify-start tw-mt-4">
      <div
        v-if="document.document_name"
        class="tw-w-full tw-border tw-border-gray dark:tw-border-dm-gray tw-rounded-xl tw-p-2 tw-flex tw-items-center"
      >
        <icon-attachment class="tw-ml-3 tw-mr-2 tw-w-4" />
        <span class="tw-flex-1 tw-font-medium tw-text-ellipsis">
          {{ document.document_name.substring(0, maxFilenameLabelLength - 3) }}...
        </span>
        <i-button
          size="small"
          is-icon
          @click.stop="downloadFileByUrlV2(`${foreignerBaseURLv1}/permit/${permit.id}/document/${document.id}/`, document.document_name, $axios)"
        >
          <icon-download />
        </i-button>
      </div>
      <template v-if="document.status === 10 || document.status === 20">
        <i-button
          type="primary"
          size="large"
          class="tw-h-12 tw-w-min"
          :is-loading="isLoading"
          @click="$refs.UploadInput.click()"
        >
          <icon-upload />
          {{ $t('common.fields.file_upload') }}
          <input
            ref="UploadInput"
            type="file"
            class="tw-hidden"
            multiple
            @change="(event) => uploadFile(event.target.files)"
          >
        </i-button>
      </template>
    </div>
  </div>
</template>

<script>
import { downloadFileByUrlV2 } from '@/helpers';
import { throttle } from 'lodash/function';

export default {
  props: {
    document: {
      type: Object,
      required: true,
    },
    permit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      windowWidth: window.innerWidth,
      foreignerBaseURLv1: `${import.meta.env.VITE_HOSTURL}/backend/api_foreigner`,
    };
  },
  computed: {
    documentStatus() {
      return this.$store.state.v2.foreigner.permits.documentStatuses.find(({ id }) => this.document && id === this.document.status);
    },
    maxFilenameLabelLength() {
      if (window.innerWidth < 768) {
        return 24;
      }
      if (window.innerWidth < 1024) {
        return 28;
      }
      if (window.innerWidth < 1280) {
        return 50;
      }
      if (window.innerWidth < 1536) {
        return 68;
      }
      return 87;
    },
  },
  mounted() {
    this.handleResize = throttle(() => {
      this.windowWidth = window.innerWidth;
    }, 200);

    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  methods: {
    downloadFileByUrlV2,
    async uploadFile(files) {
      if (files.length > 0) {
        try {
          this.isLoading = true;
          await this.$store.dispatch('v2/foreigner/permits/uploadDocument', {
            documents: Array.from(files),
            permitId: this.permit.id,
            documentId: this.document.id,
          });
          this.$store.dispatch('v2/foreigner/permits/loadDocuments', this.permit.id);
        } catch (e) {

        } finally {
          this.isLoading = false;
          this.$refs.UploadInput.value = '';
        }
      }
    },
  },
};
</script>
